import React from 'react';
import { Facebook, Twitter, Instagram, Linkedin, MapPin, Phone, Mail, Clock } from 'lucide-react';
import { contactInfo } from '../mock';
import Logo from './Logo';

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) {
    const y = el.getBoundingClientRect().top + window.pageYOffset - 90;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }
};

export default function Footer() {
  const cols = [
    { title: 'Services', links: [
      { label: 'Business Loans', id: 'business-loans' },
      { label: 'Merchant Cash Advance', id: 'merchant-cash-advance' },
      { label: 'Card Terminals', id: 'card-terminals' },
      { label: 'EPOS Systems', id: 'epos-systems' },
      { label: 'Business Funding', id: 'business-funding' },
      { label: 'Commercial Finance', id: 'commercial-finance' },
    ]},
    { title: 'Company', links: [
      { label: 'About Us', id: 'why' },
      { label: 'How It Works', id: 'how' },
      { label: 'Reviews', id: 'testimonials' },
      { label: 'FAQ', id: 'faq' },
      { label: 'Contact', id: 'contact' },
    ]},
    { title: 'Resources', links: [
      { label: 'Get a Quote', id: 'quote' },
      { label: 'Support Centre', id: 'contact' },
      { label: 'Fee Calculator', id: 'quote' },
    ]},
  ];
  return (
    <footer id="contact" className="bg-[#061a2e] text-slate-300 scroll-mt-24">
      <div className="max-w-7xl mx-auto px-6 py-20">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <Logo variant="light" height={110} />
            <p className="mt-4 text-[13px] font-semibold tracking-[0.18em] uppercase text-teal-400">
              Smart Finance. Stronger Business.
            </p>
            <p className="mt-5 text-sm text-slate-400 leading-relaxed max-w-sm">
              Fast, flexible business finance built for the modern UK business. Founded 2018.
            </p>

            <ul className="mt-8 space-y-3 text-sm">
              <li className="flex items-start gap-3"><MapPin size={16} className="text-teal-400 mt-0.5 flex-shrink-0"/> {contactInfo.address}</li>
              <li><a href="tel:01217586892" className="flex items-center gap-3 hover:text-teal-400 transition-colors"><Phone size={16} className="text-teal-400 flex-shrink-0"/> {contactInfo.phone}</a></li>
              <li><a href="mailto:info@sleekbusiness.co.uk" className="flex items-center gap-3 hover:text-teal-400 transition-colors"><Mail size={16} className="text-teal-400 flex-shrink-0"/> {contactInfo.email}</a></li>
              <li><a href="mailto:support@sleekbusiness.co.uk" className="flex items-center gap-3 hover:text-teal-400 transition-colors"><Mail size={16} className="text-teal-400 flex-shrink-0"/> {contactInfo.emailSupport}</a></li>
              <li className="flex items-center gap-3"><Clock size={16} className="text-teal-400 flex-shrink-0"/> {contactInfo.hours}</li>
            </ul>
          </div>

          <div className="lg:col-span-8 grid sm:grid-cols-2 md:grid-cols-3 gap-8">
            {cols.map((c) => (
              <div key={c.title}>
                <div className="text-white font-semibold text-sm uppercase tracking-wider">{c.title}</div>
                <ul className="mt-5 space-y-3">
                  {c.links.map(l => (
                    <li key={l.label}>
                      <button onClick={() => scrollTo(l.id)} className="text-sm text-slate-400 hover:text-teal-400 transition-colors text-left">
                        {l.label}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-wrap items-center justify-between gap-4">
          <div className="text-xs text-slate-500">© {new Date().getFullYear()} Sleek Business Ltd. All rights reserved.</div>
          <div className="flex items-center gap-3">
            {[Facebook, Twitter, Instagram, Linkedin].map((Icon, i) => (
              <a key={i} href="#" aria-label="social link" className="h-9 w-9 rounded-full border border-white/10 flex items-center justify-center text-slate-400 hover:text-teal-400 hover:border-teal-400 transition-colors">
                <Icon size={16}/>
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
